import { css } from '@emotion/core';
import HomeContent from './HomeContent';

export default function HomeLayoutDesktop() {
    return (
        <div
            css={css`
                padding: 2rem;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
            `}
        >
            <HomeContent />
        </div>
    );
}
